import { UserWeddingRole, Wedding } from "./wedding";

export type User = {
  _id: string;
  accountID: string;
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  businessName: string;
  userWeddingRole: UserWeddingRole;
  weddingID: string;
  profilePicture: string;
  tempProfilePicture: string;
  isVerified: boolean;
  platformAccountID: string;
  hasNotOnboarded: boolean;
  createdAt: Date;
};

export const createDefaultUser = (): User => ({
  _id: "",
  accountID: "",
  firstname: "",
  lastname: "",
  email: "",
  password: "",
  userWeddingRole: UserWeddingRole.Groom,
  isVerified: false,
  businessName: "",
  weddingID: "",
  profilePicture: "",
  tempProfilePicture: "",
  platformAccountID: "",
  hasNotOnboarded: false,
  createdAt: new Date(),
});

export type WeddingUsers = {
  wedding: Wedding;
  eventPlanner: User;
  groom: User;
  bride: User;
  guestManager: User;
};
